export default __webpack_public_path__ + "static/media/nwjbl.629e9d30.png";